import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useParams, Navigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getProject, isValidDoc, getDocFile } from '../data/legalDocs';
import { useLanguage } from '../i18n/LanguageContext';

const LegalDoc = ({ isWebview }) => {
  const { project: slug, doc } = useParams();
  const { t, lang } = useLanguage();
  const project = getProject(slug);
  const valid = project && isValidDoc(doc);

  const [content, setContent] = useState('');
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!valid) return undefined;

    let active = true;
    setStatus('loading');

    fetch(`${process.env.PUBLIC_URL}/legal/${getDocFile(slug, doc, lang)}`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.text();
      })
      .then((text) => {
        if (!active) return;
        setContent(text);
        setStatus('done');
      })
      .catch(() => {
        if (active) setStatus('error');
      });

    return () => {
      active = false;
    };
  }, [slug, doc, lang, valid]);

  if (!valid) return <Navigate to="/legal" replace />;

  const label = t.legal.docTypes[doc];

  return (
    <>
      <Helmet>
        <title>{label} — {project.name} — Havel br</title>
        <meta name="description" content={`${label} — ${project.name} · Havel br`} />
      </Helmet>

      <div className="container">
        <div className={`legal-content ${!isWebview ? 'web-content' : ''}`}>
          {!isWebview && (
            <p className="legal-back">
              <Link to="/legal">{t.legal.back}</Link>
            </p>
          )}

          {status === 'loading' && <p>{t.legal.loading}</p>}
          {status === 'error' && (
            <p>
              {t.legal.error} <a href="mailto:contato@havel.com.br">contato@havel.com.br</a>.
            </p>
          )}
          {status === 'done' && (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          )}
        </div>
      </div>
    </>
  );
};

export default LegalDoc;
